/*
 * Intercepts HTTP AJAX errors and passes the error message to a toast dispatcher.
 */
(function() {
    'use strict';

    angular.module('paysera.toast')
        .factory('toastInterceptor', interceptorFactory)
        .config(['$httpProvider', function($httpProvider) {
            $httpProvider.interceptors.push('toastInterceptor');
        }]);

    interceptorFactory.$inject = ['$q', '$log', 'toastDispatcher', 'errorExtractor', 'successMessageExtractor'];

    function interceptorFactory($q, $log, toastDispatcher, errorExtractor, successMessageExtractor) {
        return {
            responseError: function(response) {
                $log.debug('toastInterceptor:responseError', response);
                if (
                    response.status !== 0 //aborted request
                    && response.hasOwnProperty('config')
                    && response['config'].hasOwnProperty('error_context')
                    && response['config']['error_context'] !== null
                    && (
                        !response['config'].hasOwnProperty('error_exclude_statuses')
                        || response['config']['error_exclude_statuses'].indexOf(response.status) === -1
                    )
                ) {
                    toastDispatcher.error(errorExtractor.extract(response));
                }
                return $q.reject(response);
            },
            response: function(response) {
                if (
                    response.status !== 0 //aborted request
                    && response.status === 200
                    && response.hasOwnProperty('config')
                    && ((response.config.method === 'PUT')
                        || (response.config.method === 'POST')
                        || (response.config.method === 'DELETE')
                        || (response.config.method === 'PATCH')
                    )
                ) {
                    toastDispatcher.success(successMessageExtractor.extract(response));
                }
                return $q.resolve(response);
            }
        };
    }
})();
